module.exports = __webpack_public_path__ + "images/atlassian-logo-gray-small.9e6eec362a19b0350715.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/atlassian-logo-gray-small.svg
// module id = /UQw
// module chunks = 2